const Footer = () => {
  const year = new Date().getFullYear()
  return (
    <footer className="d-flex px-3 px-sm-5 py-4 bg-white w-100 mt-auto fs-8">
      <p className="m-0 me-3 opacity-50">{ `${ year } © Gymnastic Britannia` }</p>
      <p className="m-0 ms-auto opacity-50">
        Website created by { " " }
        <a href="https://www.charltonwebdev.com" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
          Charlton WebDev
        </a>
      </p>
    </footer>
  )
}

export default Footer